import { FC, SVGProps } from 'react'

export const Mail: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.05541 5.05546C3.57114 4.53973 4.27061 4.25 4.99996 4.25H19C19.7293 4.25 20.4288 4.53973 20.9445 5.05546C21.4602 5.57118 21.75 6.27065 21.75 7V7.9884C21.7501 7.99568 21.7501 8.00295 21.75 8.01023V17C21.75 17.7293 21.4602 18.4288 20.9445 18.9445C20.4288 19.4603 19.7293 19.75 19 19.75H4.99996C4.27061 19.75 3.57114 19.4603 3.05541 18.9445C2.53969 18.4288 2.24996 17.7293 2.24996 17V8.01026C2.24985 8.00296 2.24985 7.99567 2.24996 7.98837V7C2.24996 6.27065 2.53969 5.57118 3.05541 5.05546ZM3.74996 9.40139V17C3.74996 17.3315 3.88165 17.6495 4.11607 17.8839C4.35049 18.1183 4.66844 18.25 4.99996 18.25H19C19.3315 18.25 19.6494 18.1183 19.8838 17.8839C20.1183 17.6495 20.25 17.3315 20.25 17V9.40139L13.5262 13.8839C13.0743 14.1854 12.5432 14.3463 12 14.3463C11.4567 14.3463 10.9256 14.1854 10.4737 13.8839L3.74996 9.40139ZM20.25 7.59861L12.6939 12.636C12.4885 12.773 12.2469 12.8463 12 12.8463C11.753 12.8463 11.5116 12.7732 11.3062 12.6361L3.74996 7.59861V7C3.74996 6.66848 3.88165 6.35054 4.11607 6.11612C4.35049 5.8817 4.66844 5.75 4.99996 5.75H19C19.3315 5.75 19.6494 5.8817 19.8838 6.11612C20.1183 6.35054 20.25 6.66848 20.25 7V7.59861Z"
			fill="currentColor"
		/>
	</svg>
)
